import React from 'react';
import mintBanner from '.././ass/mintBanner.png';

export function Banner() {
  return (
    <div className='relative w-screen'>
      <img
        src={mintBanner}
        alt='Mint banner'
        className='w-full mx-auto'
        style={{ width: '70%' }}
      />
    </div>
  );
}
